import { ReactComponent as Plus } from '@img/icons/plus.svg';
import { ReactComponent as Minus } from '@img/icons/minus.svg';
import * as React from 'react';
import S from './ToggleBlock.styles';
const ToggleBlock = ({ title, children }) => {
    const [active, setActive] = React.useState(false);
    return (React.createElement(S.Container, { "data-open": active },
        React.createElement(S.Title, { onClick: (event) => {
                event.preventDefault();
                setActive(!active);
            } },
            title,
            active ? React.createElement(Minus, null) : React.createElement(Plus, null)),
        React.createElement(S.Content, null,
            React.createElement(S.Inner, null, children))));
};
export default ToggleBlock;
